import React from 'react'
import ReactDOM from 'react-dom'
import {applyMiddleware, compose, createStore} from 'redux'
import {Provider} from 'react-redux'
import {rootReducer} from './redux/reducers/rootReducer'
import thunk from 'redux-thunk'
import App from './components/Blocks/App'

const store = createStore(rootReducer, compose(
  applyMiddleware(thunk)
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
)

ReactDOM.render(
  <Provider store={store}>
      <App/>
  </Provider>, document.getElementById('root'))